import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Russian Passport generator following Single Responsibility Principle
 */
export class RuGenerator extends BaseGenerator {
  generate(options = {}) {
    const { formatted = true } = options;

    // Generate series (4 digits)
    const series = this.randomDigits(4);
    
    // Generate number (6 digits)
    const number = this.randomDigits(6);
    
    const passport = series + number;
    
    return formatted ? 
      `${series} ${number}` : 
      passport;
  }
}